// @ts-nocheck
/* eslint-disable */

"use client";

import {
  Row,
  Slider,

} from "politicamente-informados-ds";
import React from "react";

import DisplayImage from "@/components/common/DisplayImage/DisplayImage";
import { IArchiveGrid } from "@/lib/wordpress/_types/archiveGrid";




export default function BlockLogosGrid({ attrs }: IArchiveGrid) {
  const { grid } = attrs || {};
  return (
    <div>
      <Row>
        <Slider
          arrows={false}
          dots={false}
          slidesToShow={attrs.per_line}
          infinite={true}
          autoplay={true}
          mediaQueries={{
            900: {
              slidesToShow: 4
            },
            500: {
              slidesToShow: 3
            }
          }}
        >
          {grid?.items && grid?.items.length > 0 ? (
            grid?.items.map((item, index) => {
              return (

                <DisplayImage
                  width="100%"
                  height="100%"
                  sizes="100vw"
                  decoding="async"
                  src={item?.image}
                  alt={item?.title.rendered}
                />

              )
            })
          ) : (
            <p>Sem resultados</p>
          )}
        </Slider>
      </Row>
    </div >
  );
}
